// extracted by mini-css-extract-plugin
export default {"map":"index-module--map--v+Jpi"};